import { render, staticRenderFns } from "./FACE.vue?vue&type=template&id=fa5afe96"
import script from "./FACE.vue?vue&type=script&lang=js"
export * from "./FACE.vue?vue&type=script&lang=js"
import style0 from "./FACE.vue?vue&type=style&index=0&id=fa5afe96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports